import 'regenerator-runtime/runtime';

// Define __DEV__ global for React Native Web
if (typeof __DEV__ === 'undefined') {
  global.__DEV__ = process.env.NODE_ENV !== 'production';
}

import { AppRegistry } from 'react-native';
import App from './src/App';

// App name
const appName = 'EverydayGoal';

// Register the app
AppRegistry.registerComponent(appName, () => App);

// Run the app in the web
AppRegistry.runApplication(appName, {
  rootTag: document.getElementById('root'),
});
